import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, Ref, ref } from 'vue';

import ModalDialog, { ModalDialogApi } from '@/components/dialogs/ModalDialog.vue';
import BrowserDetection from '@/data/BrowserDetection';
import { ChatSummary } from '@/data/datatypes/ChatSummary';
import { Track } from '@/data/datatypes/Track';

interface Props {
  track: Track;
}
interface Emits {
  (e: 'close'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSummaryDialog',
  props: {
    track: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  track: Track;
}

const MAX_WORKSPACE_TITLE_SIZE: number = 25;
const MAX_THREAD_TITLE_SIZE: number = 75;





const modal: Ref<ModalDialogApi | null> = ref(null);

const isMobile: ComputedRef<boolean> = computed(() => {
  return BrowserDetection.isMobile();
});

const mainSummaryText: ComputedRef<string> = computed(() => {
  if (props.track.chatSummaries && props.track.chatSummaries.length > 0) {
    for (const chatSummary of props.track.chatSummaries) {
      if (!chatSummary.parentMessageId) {
        return chatSummary.summary;
      }
    }
  }
  return 'Chat summary not available.';
});

const threadSummaries: ComputedRef<ChatSummary[]> = computed(() => {
  const toReturn: ChatSummary[] = [];
  if (props.track.chatSummaries && props.track.chatSummaries.length > 0) {
    for (const chatSummary of props.track.chatSummaries) {
      if (chatSummary.parentMessageId) {
        toReturn.push(chatSummary);
      }
    }
  }
  return toReturn;
});

const hasThreads: ComputedRef<boolean> = computed(() => {
  return threadSummaries.value.length > 0;
});

const dialogTitle: ComputedRef<string> = computed(() => {
  let ellipsis = false;
  if (props.track.title && props.track.title.length > MAX_WORKSPACE_TITLE_SIZE) {
    ellipsis = true;
  }

  let trackTitle = props.track.title?.substring(0, MAX_WORKSPACE_TITLE_SIZE);
  if (ellipsis) {
    trackTitle = trackTitle + '...';
  }

  if (threadSummaries.value.length > 0) {
    return trackTitle + ' message summaries';
  }
  return trackTitle + ' message summary';
});

function okClicked(): void {
  modal.value?.closeDialog();
  emit('close');
}

function threadMessageToDisplay(chatSummary: ChatSummary): string | undefined {
  let ellipsis = false;
  if (chatSummary.parentMessagePlainText && chatSummary.parentMessagePlainText.length > MAX_THREAD_TITLE_SIZE) {
    ellipsis = true;
  }
  let toReturn = chatSummary.parentMessagePlainText?.substring(0, MAX_THREAD_TITLE_SIZE);
  if (ellipsis) {
    toReturn = toReturn + '...';
  }
  return toReturn;
}

return { __sfc: true,MAX_WORKSPACE_TITLE_SIZE, MAX_THREAD_TITLE_SIZE, props, emit, modal, isMobile, mainSummaryText, threadSummaries, hasThreads, dialogTitle, okClicked, threadMessageToDisplay, ModalDialog }
}

})